import axios from 'axios';
import { EventBus } from '@/event-bus.js';
import { BUILD_VERSION } from '../config';

const actions = {
  getCurrent({ commit, state }) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line
      console.log('Version reloading disabled in development mode.');
      return;
    }
    axios.get(`/version.json?ts=${Date.now()}`).then((r) => {
      commit('updateRemote', r.data.current);

      if (state.localVersion !== state.remoteVersion) {
        EventBus.$emit('confirm', {
          message: 'Great news! A new version of Seer is available. Click here to update now.',
          positiveText: 'Update',
          callback: (confirm) => {
            if (confirm) {
            // eslint-disable-next-line
            location.reload();
            }
          },
        });
      }
    });
  },
};
const mutations = {
  updateRemote(state, value) {
    state.remoteVersion = value;
  },
};
const state = {
  localVersion: BUILD_VERSION || '0',
  remoteVersion: BUILD_VERSION || '0',
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
